import { render, staticRenderFns } from "./MajorScoreSegment.vue?vue&type=template&id=3f2e9fe9"
import script from "./MajorScoreSegment.vue?vue&type=script&lang=js"
export * from "./MajorScoreSegment.vue?vue&type=script&lang=js"
import style0 from "./MajorScoreSegment.vue?vue&type=style&index=0&id=3f2e9fe9&prod&lang=less"
import style1 from "./MajorScoreSegment.vue?vue&type=style&index=1&id=3f2e9fe9&prod&scope=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports